/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookClosedIcon16Light = forwardRef('BookClosedIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.5 4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 3.25V13.5A1.5 1.5 0 0 0 3.5 15h9a.5.5 0 0 0 0-1h-9a.5.5 0 0 1 0-1h9a.5.5 0 0 0 .5-.5V2a1 1 0 0 0-1-1H4.25A2.25 2.25 0 0 0 2 3.25ZM4.25 2C3.56 2 3 2.56 3 3.25v8.835c.156-.055.325-.085.5-.085H12V2H4.25Z" })));
});
